<!-- Content -->
<div
  class="content container-fluid"
  *ngIf="serieProposal$ | async as serieProposal"
>
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">
          {{ (productEntities$ | async)[serieProposal.productId]?.description }}
        </li>
      </ol>
    </nav>

    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'serieProposalModule.serieProposal' | translate }}:
        {{ (productEntities$ | async)[serieProposal.productId]?.description }}
        -
        {{
          (memberEntities$ | async)[serieProposal?.customerPersonId]?.firstName
        }}
        {{
          (memberEntities$ | async)[serieProposal?.customerPersonId]?.lastName
        }}
      </h1>

      <div class="ms-3">
        <button
          type="button"
          *ngIf="serieProposal.status == serieProposalStatus.COUNTER_PROPOSAL"
          class="btn btn-ghost-primary"
          (click)="onClickShowInitialRequest(serieProposal)"
        >
          {{ 'serieProposalModule.showInitialRequest' | translate }}
        </button>

        <button class="btn btn-sm btn-white" type="button">
          <span
            class="badge fs-6"
            [ngClass]="{
              'bg-soft-primary':
                serieProposal?.status == serieProposalStatus.REQUESTED,
              'bg-soft-warning':
                serieProposal?.status == serieProposalStatus.COUNTER_PROPOSAL,
              'bg-soft-success':
                serieProposal?.status == serieProposalStatus.ACCEPTED,
              'bg-soft-danger':
                serieProposal?.status == serieProposalStatus.DECLINED
            }"
          >
            {{
              'serieProposalModule.serieProposalStatus' + serieProposal?.status
                | translate
            }}</span
          >
        </button>
      </div>
    </div>
  </header>
  <!-- End Page Header -->
  <nav attr.aria-label="{{ 'wcag.serieProposalMenu' | translate }}">
    <ul
      class="nav nav-tabs align-items-center mb-3"
      *ngIf="serieProposal"
      role="tablist"
    >
      <!-- WCAG SKIP link -->
      <!-- <li class="nav-item">
        <a href="#serieProposal" class="nav-link visually-hidden-focusable"
          ><span>{{ 'wcag.skipNavigation' | translate }}</span></a
        >
      </li> -->
      <!-- END WCAG skip link -->
      <li class="nav-item">
        <a
          class="nav-link"
          [routerLink]="['/bookings/serie-proposals', serieProposal.id]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="setActiveTab('general')"
          role="tab"
          #rla="routerLinkActive"
          [attr.aria-selected]="rla.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa me-1 fa-cube" aria-hidden="true"></i>
          {{ 'general.general' | translate }}
        </a>
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          [routerLink]="[
            '/bookings/serie-proposals',
            serieProposal.id,
            'series'
          ]"
          (click)="setActiveTab('serie')"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="tab"
          #rla1="routerLinkActive"
          [attr.aria-selected]="rla1.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa me-1 fa-stream" aria-hidden="true"></i>
          {{ 'serieProposalModule.serie' | translate }}
        </a>
      </li>
      <li class="nav-item position-relative">
        <a
          class="nav-link"
          [routerLink]="[
            '/bookings/serie-proposals',
            serieProposal.id,
            'messages'
          ]"
          (click)="setActiveTab('messages')"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          role="tab"
          #rla2="routerLinkActive"
          [attr.aria-selected]="rla2.isActive ? 'true' : 'false'"
        >
          <i role="img" class="fa fa-comment me-1" aria-hidden="true"></i>
          {{ 'general.messages' | translate }}
        </a>

        <span
          *ngIf="messageService.hasNewMessage(serieProposal)"
          class="badge bg-primary position-absolute"
          style="top: 0px; right: -10px"
        >
          {{ 'general.new' | translate }}
        </span>
      </li>
    </ul>
  </nav>
  <!-- End Nav -->

  <div class="w-100" id="serieProposal">
    <router-outlet></router-outlet>
  </div>
</div>
